import React, { useState, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CardUnitJadwal from "../../components/CardUnit/CardUnitJadwal";
import FilterJadwalLelang from "../../components/Filters/FilterJadwalLelang";
import "../../assets/css/component.css";
import withoutAuth from "../../services/withoutAuthProvider";
import { format } from "date-fns";
import MoreButton from "../../components/MoreButton/MoreButton";
import { useHistory } from "react-router-dom";
import { SkeletonJadwal } from "../../components/Skeleton/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import { actionsPage } from "../../redux/page.slice";
import { subdomainSelector } from "../../redux/subdomain.slice";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useBalancedData } from "../../hooks/useStaleWhileRevalidate";
import toast from "react-hot-toast";
const initialPaginate = {
  page_size: 12,
  location_id: "",
  unit_type_id: "",
};

export default function JadwalLelangHariIni() {
  const date = useMemo(() => format(new Date(), "yyyy-MM-dd"), []);
  const { push } = useHistory();
  const dispatch = useDispatch();
  const [paginate, setPaginate] = useState({ ...initialPaginate });
  const subdomain = useSelector(subdomainSelector);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPaginate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Filters UseQuery - Cache 5 menit sesuai Cache Duration.md
  const { data: locations = [] } = useBalancedData(
    ["locations"],
    async () => {
      const response = await withoutAuth.getDataWithoutAuth("/api/location", {});
      return response?.status === 200 ? response.data.data.data : [];
    },
    { cacheTime: 1000 * 60 * 5 } // 5 menit
  );

  const { data: unitTypes = [] } = useBalancedData(
    ["unitTypes"],
    async () => {
      const response = await withoutAuth.getDataWithoutAuth("/api/unit-type", {});
      return response?.status === 200 ? response.data.data.data : [];
    },
    { cacheTime: 1000 * 60 * 5 } // 5 menit
  );

  // Main Data UseInfiniteQuery - Cache 5 menit sesuai Cache Duration.md
  const { data, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } = useInfiniteQuery(
    ["jadwalLelangHariIni", paginate.location_id, paginate.unit_type_id, subdomain],
    async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        page_size: paginate.page_size,
        start_date: date,
        end_date: date,
      };
      if (paginate.location_id !== "") {
        params.location_id = paginate.location_id;
      }
      if (paginate.unit_type_id !== "") {
        params.unit_type_id = paginate.unit_type_id;
      }
      if (subdomain !== "global") {
        params.exclusive_seller_slug = subdomain;
      }
      const response = await withoutAuth.getDataWithoutAuth("/api/auction", params);
      if (response?.status === 200) {
        return response.data.data;
      }
      throw new Error(response?.data?.message || "Failed to fetch schedules");
    },
    {
      cacheTime: 1000 * 60 * 5, // 5 menit sesuai Cache Duration.md
      staleTime: 0,
      getNextPageParam: (lastPage) => {
        if (lastPage.current_page < lastPage.last_page) {
          return lastPage.current_page + 1;
        }
        return undefined;
      },
      keepPreviousData: true,
      onError: (err) => {
        toast.error(err.message);
      },
    }
  );

  const units = useMemo(() => {
    return data?.pages?.flatMap((page) => page.data) || [];
  }, [data]);

  return (
    <div className="jadwalLelang">
      <div>
        <Container>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <FilterJadwalLelang
                show={1}
                data={paginate}
                locations={locations}
                unitTypes={unitTypes}
                handleChange={handleChange}
              />
              <div className="row" style={{ marginBottom: "16px" }}>
                {isLoading ? (
                  new Array(8).fill(1).map((el, idx) => (
                    <div className="col-6 col-md-4 col-xl-3 mb-4" key={`skeleton jadwal-${idx}`}>
                      <SkeletonJadwal />
                    </div>
                  ))
                ) : units.length > 0 ? (
                  units.map((el, idx) => (
                    <div className="col-6 col-md-4 col-xl-3 mb-4" key={idx}>
                      <CardUnitJadwal
                        auctionCategory={el?.auction_category}
                        status={el?.status}
                        tanggalAkhir={el?.date_finish}
                        id={el?.id}
                        judul={el?.name || "-"}
                        tanggal={el?.date_start}
                        waktu={`${el?.time_start?.substr(0, 5)} - ${el?.time_finish?.substr(0, 5)} WIB`}
                        lokasi={el?.location?.name || "-"}
                        live={el?.is_started}
                        onClick={() => {
                          if (el?.is_exclusive && subdomain === "global") {
                            window.open(
                              "https://" + el?.exclusive_seller_slug + "." + window.location.hostname + "/unit-lelang"
                            );
                          } else {
                            dispatch(actionsPage.setPage({ page: 0 }));
                            push("/unit-lelang", {
                              dataFilter: {
                                auction_id: el?.id,
                                unit_type_id: el?.unit_type?.id,
                                isTimeBid: el?.auction_category === "TIME-BID",
                              },
                            });
                          }
                        }}
                        unit_type_image={el?.unit_type?.banner_url}
                      />
                    </div>
                  ))
                ) : (
                  <div className="text-secondary text-center mt-5">Tidak ada jadwal lelang</div>
                )}
              </div>
            </Col>
          </Row>
          {hasNextPage && <MoreButton onClick={fetchNextPage} loading={isFetchingNextPage} />}
        </Container>
      </div>
    </div>
  );
}
